import { useState } from "react";
import "@/App.css";
import { motion, AnimatePresence } from "framer-motion";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Skills } from "@/components/Skills";
import { Projects } from "@/components/Projects";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="App bg-[#050505] min-h-screen">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" />
      
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          onAnimationComplete={() => setIsLoaded(true)}
        >
          <Header />
          <main>
            <Hero isLoaded={isLoaded} />
            <About />
            <Skills />
            <Projects />
            <Contact />
          </main>
          <Footer />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default App;
